import { useGetOGPUserInfo } from 'ogp/hooks';

export const useIsHqImpersonation = () => {
  const userQuery = useGetOGPUserInfo();
  return userQuery.data?.userInfo.impersonatedByHq ?? false;
};
